(function() {
  function initGlobalRewardBar() {
    const bar = document.querySelector('.ai-custom-reward-bar-element');
    if (!bar || bar.classList.contains('js-initialized')) return;

    const rewardType = bar.dataset.rewardType || 'amount';
    const goalAmount = (parseFloat(bar.dataset.goalAmount) || 0) * 1000;
    const goalQuantity = parseInt(bar.dataset.goalQuantity) || 0;
    const giftProductId = bar.dataset.giftProductId || '';
    const giftVariantId = bar.dataset.giftVariantId || '';
    const requiredTag = bar.dataset.requiredTag ? bar.dataset.requiredTag.trim() : '';
    
    const messageEl = bar.querySelector('[data-message]');
    const progressFillEl = bar.querySelector('[data-progress-fill]');
    const giftPreviewEl = bar.querySelector('[data-gift-preview]');

    const progressTextAmount = bar.dataset.progressTextAmount || 'Te faltan {remaining} para tu regalo';
    const successTextAmount = bar.dataset.successTextAmount || '¡Felicidades! Tienes un regalo 🎉';
    const progressTextQuantity = bar.dataset.progressTextQuantity || 'Agrega {remaining} producto(s) más para tu regalo';
    const successTextQuantity = bar.dataset.successTextQuantity || '¡Felicidades! Tienes un regalo 🎉';
    const progressTextCheapest = bar.dataset.progressTextCheapest || 'Agrega {remaining} producto(s) más y el más barato es gratis';
    const successTextCheapest = bar.dataset.successTextCheapest || '¡Felicidades! El producto más barato es gratis 🎉';

    let isProcessing = false;

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(0);
      return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    async function updateBarLogic() {
      try {
        // Solicitamos el carrito con el parámetro adicional para obtener los tags del producto de forma nativa en Shopify
        const res = await fetch('/cart.js?view=intents&t=' + Date.now());
        if (!res.ok) return;
        const cart = await res.json();

        if (giftPreviewEl) {
          giftPreviewEl.style.display = rewardType === 'cheapest_free' ? 'none' : 'flex';
        }

        // --- FILTRADO POR TAG CRÍTICO ---
        let finalItems = cart.items || [];
        
        // Si hay una etiqueta requerida configurada, filtramos la lista de productos válidos
        if (requiredTag !== '') {
          finalItems = finalItems.filter(item => {
            // Saltarse el regalo clonado si ya está en el carrito para que no se autocalcule
            if (item.properties && (item.properties._gift || item.properties._discount_applied)) {
              return false;
            }
            
            // Los tags en la API de Shopify a veces vienen en item.product_tags o en un string.
            // Para asegurar compatibilidad con temas antiguos/modernos, revisamos ambas opciones:
            if (item.product_tags && Array.isArray(item.product_tags)) {
              return item.product_tags.includes(requiredTag);
            }
            if (item.handle) {
              // Si el objeto simplificado no trae los tags directos, este flag maneja el fallback seguro
              // Pero en temas modernos de Shopify, 'product_tags' se incluye por defecto en cart.js
              return true; 
            }
            return true;
          });
        }

        // Recalculamos los totales basándonos únicamente en los productos filtrados (válidos)
        const totalValidoPrice = finalItems.reduce((sum, item) => sum + (item.final_line_price || item.line_price), 0);
        const totalValidoCount = finalItems.reduce((sum, item) => sum + item.quantity, 0);
        const totalGeneralCount = (cart.items || []).reduce((sum, item) => sum + item.quantity, 0);

        if (rewardType === 'cheapest_free') {
          // Lógica Producto Más Barato Gratis (Filtrado)
          const discountedItems = (cart.items || []).filter(item => item.properties && item.properties._discount_applied);
          
          if (discountedItems.length > 0 && totalGeneralCount >= goalQuantity) {
            progressFillEl.style.width = '100%';
            messageEl.innerHTML = successTextCheapest;
            return;
          }
          if (totalValidoCount >= goalQuantity) {
            progressFillEl.style.width = '100%';
            messageEl.innerHTML = successTextCheapest;
            if (!isProcessing && finalItems.length > 0) {
              isProcessing = true;
              let cheapest = finalItems[0];
              for (let i = 1; i < finalItems.length; i++) {
                if (finalItems[i].price < cheapest.price) cheapest = finalItems[i];
              }
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: cheapest.key, quantity: cheapest.quantity - 1 })
              });
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: cheapest.variant_id, quantity: 1, properties: { '_discount_applied': 'true' } })
              });
              isProcessing = false;
              window.location.reload();
            }
          } else {
            const remaining = goalQuantity - totalValidoCount;
            progressFillEl.style.width = Math.min((totalValidoCount / goalQuantity) * 100, 100) + '%';
            messageEl.innerHTML = progressTextCheapest.replace('{remaining}', remaining);
          }

        } else {
          // Lógica Estándar: Monto o Cantidad (Filtrado)
          const currentValue = rewardType === 'amount' ? totalValidoPrice / 100 : totalValidoCount;
          const goal = rewardType === 'amount' ? goalAmount : goalQuantity;
          const progress = Math.min((currentValue / goal) * 100, 100);

          progressFillEl.style.width = progress + '%';
          const giftInCart = (cart.items || []).some(item => item.product_id == giftProductId || (item.properties && item.properties._gift));

          if (currentValue >= goal) {
            messageEl.innerHTML = rewardType === 'amount' ? successTextAmount : successTextQuantity;
            if (!giftInCart && !isProcessing && giftVariantId) {
              isProcessing = true;
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: giftVariantId, quantity: 1, properties: { '_gift': 'true' } })
              });
              isProcessing = false;
              window.location.reload();
            }
          } else {
            const remaining = Math.max(0, goal - currentValue);
            const txt = rewardType === 'amount' ? progressTextAmount : progressTextQuantity;
            const formatted = rewardType === 'amount' ? formatMoney(remaining * 100) : remaining;
            messageEl.innerHTML = txt.replace('{remaining}', formatted);
          }
        }
      } catch (e) {
        console.error(e);
      }
    }

    bar.classList.add('js-initialized');
    updateBarLogic();

    const cartEvents = ['cart:updated', 'cart:changed', 'ajaxProduct:added', 'theme:cart:changed'];
    cartEvents.forEach(evt => {
      document.addEventListener(evt, () => { setTimeout(updateBarLogic, 300); });
    });

    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        return originalFetch.apply(this, arguments).then(res => {
          setTimeout(updateBarLogic, 500);
          return res;
        });
      }
      return originalFetch.apply(this, arguments);
    };
  }

  document.addEventListener('DOMContentLoaded', initGlobalRewardBar);
  setTimeout(initGlobalRewardBar, 1000);
  
  const observer = new MutationObserver(initGlobalRewardBar);
  observer.observe(document.body, { childList: true, subtree: true });
})();